const appInfo = {
    title: 'Private GPT'
};
export default appInfo;

